import BonnetWebcomponent from './BonnetWebcomponent';

export default BonnetWebcomponent;
